// import * as VComponent from '../../../src';
import * as VComponent from 'react-validate-component';

const VCheckbox = VComponent.VCheckbox;
const VColor = VComponent.VColor;
const VDate = VComponent.VDate;
const VEmail = VComponent.VEmail;
const VRadio = VComponent.VRadio;
const VRange = VComponent.VRange;
const VText = VComponent.VText;
const VURL = VComponent.VURL;

export { VCheckbox, VColor, VDate, VEmail, VRadio, VRange, VText, VURL };
